(() => {
  function moneyFromDataset(el) {
    return el?.dataset?.priceText || '';
  }

  function initPurchase(root) {
    if (!root || root.dataset.mcReady === 'true') return;
    root.dataset.mcReady = 'true';

    const variantSelect = root.querySelector('[data-mc-variant]');
    const planInput = root.querySelector('[data-mc-selling-plan]');
    const submit = root.querySelector('[data-mc-submit]');
    const status = root.querySelector('[data-mc-status]');
    const price = root.closest('.mc-product-box')?.querySelector('[data-mc-price]');
    const requiresPlan = root.dataset.requirePlan === 'true';

    function visiblePlanPanel() {
      if (!variantSelect) return null;
      return root.querySelector(`[data-mc-plans-for="${variantSelect.value}"]`);
    }

    function selectPlan(radio) {
      if (!planInput) return;
      planInput.value = radio ? radio.value : '';
      if (radio) {
        root.querySelectorAll('[data-mc-plan-radio]').forEach(r => { r.checked = (r === radio); });
        const planPrice = radio.dataset.priceText;
        if (price && planPrice) price.textContent = planPrice;
      }
    }

    function refresh() {
      const selectedOption = variantSelect?.selectedOptions?.[0];
      root.querySelectorAll('[data-mc-plans-for]').forEach(panel => {
        panel.hidden = !variantSelect || panel.dataset.mcPlansFor !== variantSelect.value;
      });

      if (price && selectedOption?.dataset.priceText) price.textContent = selectedOption.dataset.priceText;

      const panel = visiblePlanPanel();
      const firstPlan = panel?.querySelector('[data-mc-plan-radio]');
      if (requiresPlan) {
        selectPlan(firstPlan || null);
        if (submit) submit.disabled = !firstPlan || selectedOption?.dataset.available === 'false';
        if (status) {
          status.textContent = !firstPlan
            ? 'This renewal needs a Shopify subscription selling plan attached to the selected variant.'
            : (selectedOption?.dataset.available === 'false' ? 'This option is currently unavailable.' : '');
        }
      } else {
        if (planInput) planInput.value = '';
        if (submit) submit.disabled = selectedOption?.dataset.available === 'false';
        if (status) status.textContent = selectedOption?.dataset.available === 'false' ? 'This option is currently unavailable.' : '';
      }
    }

    variantSelect?.addEventListener('change', refresh);
    root.querySelectorAll('[data-mc-plan-radio]').forEach(radio => {
      radio.addEventListener('change', () => selectPlan(radio));
    });
    refresh();
  }

  function boot(scope = document) {
    scope.querySelectorAll('[data-mc-purchase]').forEach(initPurchase);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  document.addEventListener('shopify:section:load', event => boot(event.target));
})();